import { render, staticRenderFns } from "./addPlatform.vue?vue&type=template&id=6f94c276&scoped=true"
import script from "./addPlatform.vue?vue&type=script&lang=ts"
export * from "./addPlatform.vue?vue&type=script&lang=ts"
import style0 from "./addPlatform.vue?vue&type=style&index=0&id=6f94c276&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f94c276",
  null
  
)

export default component.exports